const errorHandler = (error: unknown) => {
  if (error instanceof Error) {
    return Promise.reject(error);
  }
  return Promise.reject(new Error(JSON.stringify(error)));
};

export default errorHandler;
